import { breakpoints } from "@/theme/layout";
import useWindowSize from "./useWindowSize";

export const useWindowIsMobile = () => {
  const { width } = useWindowSize();
  const isMobile = width <= breakpoints.px.tablet;

  return isMobile;
};
